module.exports = __webpack_public_path__ + "img/252.edee896e.jpg";